import React from 'react';
import SectionTitle from '../shared/section-titles';
import fStep1 from '../../images/business/step-1.svg';
import fStep2 from '../../images/business/step-2.svg';
import fStep3 from '../../images/business/step-3.svg';
import { Link } from 'gatsby';
export const FinalStep = () => {
  window.history.pushState("", "", '/checkout/gotovo');
  return (<>
    <div>
      <div className='container text-center py-5'>
        <SectionTitle>
          <h1 className='text-white'>Супер! Всичко е наред.</h1>
          <hr className='center white' />
        </SectionTitle>
        <div className='row mt-5 d-flex justify-content-center text-center text-lg-left'>
          <div className='col-12 col-md-6 px-4 my-2 mx-1 d-flex justify-content-between align-items-center row'>
            <div className='col-12 col-lg-3'>
              <img src={fStep1} className='img-fluid my-1' alt='Стъпка 1' />
            </div>
            <div className='col-12 col-lg-9'>
              <h3 className='text-white'>Очаквайте обаждане до 2 работни часа за потвърждение</h3>
            </div>
          </div>
          <div className='col-12 col-md-6 px-4 my-2 mx-1 d-flex justify-content-between align-items-center row'>
            <div className='col-12 col-lg-3'>
              <img src={fStep2} className='img-fluid my-1' alt='Стъпка 2' />
            </div>
            <div className='col-12 col-lg-9'>
              <h3 className='text-white'>Посещение от техници в уговорения час</h3>
            </div>
          </div>
          <div className='col-12 col-md-6 px-4 my-2 mx-1 d-flex justify-content-between align-items-center row'>
            <div className='col-12 col-lg-3'>
              <img src={fStep3} className='img-fluid my-1' alt='Стъпка 3' />
            </div>
            <div className='col-12 col-lg-9'>
              <h3 className='text-white'><span className='text-green'>Voilá!</span> Вече си на вълните на Netsurf</h3>
            </div>
          </div>

        </div>
        <Link className='btn btn-primary green mt-4'>Начало</Link>
      </div>
    </div>
  </>);
};
